module.exports = {"TXTCLI_LoadingXX":{"id":"TXTCLI_LoadingXX","defaultMessage":"Wird geladen...","flags":["TRACK"],"track":"Loading..."}}